export { BookDollar as default } from './BookDollar';
